import { NOTIFICATIONS } from '../const/settings-notifications.const'

type ValueOf<T> = T[keyof T]

export const WORKSPACE_NOTIFICATION_CHANNEL = {
  EMAIL: 'email',
  IN_APP: 'inApp',
} as const

export type WorkspaceNotificationChannel = ValueOf<typeof WORKSPACE_NOTIFICATION_CHANNEL>

export type WorkspaceNotificationGroupId = keyof typeof NOTIFICATIONS

type WorkspaceNotificationGroupItems = {
  [K in WorkspaceNotificationGroupId]: ValueOf<(typeof NOTIFICATIONS)[K]>
}

export type WorkspaceNotificationId = ValueOf<WorkspaceNotificationGroupItems>

export type WorkspaceNotificationChannels = Record<WorkspaceNotificationChannel, boolean>

export type WorkspaceNotificationItem = {
  id: WorkspaceNotificationId
  groupId: WorkspaceNotificationGroupId
  channels: WorkspaceNotificationChannels
}

export type WorkspaceNotificationGroup = {
  id: WorkspaceNotificationGroupId
  items: WorkspaceNotificationItem[]
}
